(() => {
  /**
   * @ngdoc directive
   * @name kareo.ui.shared.assets:kTrackedImpression
   * @restrict E
   * @scope
   * @description
   * Renders transcluded children based on the number of times or the last time the user has seen
   * the tracking key. Records a user impression of the tracking key when shown.
   *
   * @param {string} trackingKey Unique key to track impressions of this component.
   * @param {date} maxLastOccurrence Optional. Date or moment object that hides the component when the user's last impression
   * of the tracking key is more recent than this value.
   * @param {number} maxImpressions Optional. Number of times the user can see this tracker key before it is no longer shown.
   */

  angular
    .module('kareo.ui.shared.directives.k-tracked-impression', [
      'kareo.ui.shared.modules.tracking'
    ])
    .component('kTrackedImpression', {
      controller,
      controllerAs: 'vm',
      bindings: {
        trackingKey: '@',
        maxLastOccurrence: '<?',
        maxImpressions: '<?'
      },
      template: require('./k-tracked-impression.pug')(),
      transclude: true
    });

  controller.$inject = [
    '$scope',
    'kTrackingService'
  ];

  function controller($scope, kTrackingService) {
    const vm = this;

    vm.isVisible = false;
    vm.maxLastOccurrenceValue = null;
    vm.maxImpressionsValue = null;

    vm.$onInit = onInit;
    vm.dismiss = dismiss;

    function onInit() {
      $scope.$watch(['vm.maxLastOccurrence', 'vm.maxImpressions'], determineVisibility);
    }

    function dismiss() {
      return kTrackingService.dismiss(vm.trackingKey);
    }

    function determineVisibility() {
      // If maxLastOccurrence is not defined, use a future date to ensure this check always passes
      vm.maxLastOccurrenceValue = vm.maxLastOccurrence ? moment(vm.maxLastOccurrence) : moment().add(1, 'hours');
      vm.maxImpressionsValue = (typeof vm.maxImpressions === 'number') ? vm.maxImpressions : Number.MAX_VALUE;

      kTrackingService.getUserImpressionAggregates()
        .then((userImpressionAggregates) => {
          vm.isVisible = shouldBeVisible(userImpressionAggregates);

          if (vm.isVisible) {
            kTrackingService.createUserImpression(vm.trackingKey);
          }
        });
    }

    function shouldBeVisible(userImpressionAggregates) {
      const userImpressionAggregate = userImpressionAggregates.trackers[vm.trackingKey];

      if (!userImpressionAggregate) {
        return false;
      }

      return !userImpressionAggregate.isDismissed
          && isImpressionCountValid(userImpressionAggregate.occurrenceCount)
          && isLastOccurrenceValid(userImpressionAggregate.lastOccurrence);
    }

    function isImpressionCountValid(occurrenceCount) {
      return occurrenceCount < vm.maxImpressionsValue;
    }

    function isLastOccurrenceValid(lastOccurrence) {
      return !lastOccurrence || moment(lastOccurrence).isBefore(vm.maxLastOccurrenceValue);
    }
  }
})();
